export const getCombinedOrderItemNames = (itemNames: string[]): string => {
  if (!itemNames) return '';
  if (itemNames.length === 1) {
    return itemNames[0];
  } else if (itemNames.length === 2) {
    return `${itemNames[0]} and ${itemNames[1]}`;
  } else {
    const s = itemNames.length > 3 ? 's' : '';
    return `${itemNames[0]}, ${itemNames[1]}, and ${itemNames.length - 2} more medication${s}`;
  }
};
